import { render } from "./CaseDetail.vue?vue&type=template&id=40e3aef2&scoped=true"
import script from "./CaseDetail.vue?vue&type=script&lang=js"
export * from "./CaseDetail.vue?vue&type=script&lang=js"

import "./CaseDetail.vue?vue&type=style&index=0&id=40e3aef2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e3aef2"]])

export default __exports__